import React, { Component } from "react";
import PropTypes from "prop-types";

class Modal extends Component {
    constructor(props) {
        super(props);

        this.onClose = this.onClose.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);
    }

    _handleKeyDown(event) {
        const ESCAPE_KEY = 27;

        if (event.keyCode === ESCAPE_KEY) {
            this.onClose();
        }
    }

    componentWillMount() {
        document.addEventListener("keydown", this._handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    onClose() {
        const {
            isClosable,
            onClose
        } = this.props;

        if (!isClosable) {
            return;
        }

        if (onClose) {
            onClose();
        }
    }

    render() {
        const {
            isOpen,
            isClosable,
            children,
            className
        } = this.props;

        if (!isOpen) {
            return null;
        }

        const closeButton = isClosable
            ? <button type="button" className="close-button" onClick={ this.onClose } />
            : null;

        return ( // eslint-disable-next-line
            <div className={ `modal show-modal ${ className || "" }` } onClick={ this.onClose }>
                <div className="modal-content">
                    { closeButton }
                    { children }
                </div>
            </div>
        );
    }
}

Modal.defaultProps = {
    isOpen: true,
    isClosable: true,
    onClose: () => {}
};

Modal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isClosable: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func
};

export default Modal;
